/**
 * Continuing-obligation primitive. Plan §26.3.
 * Kaiyang Lesson §25.11 / ADR-0002 red line: any card whose `obligationTiming`
 * is `post_market`, `recurring`, `event_triggered`, or `phase_in` MUST attach
 * one of these. The pairing is enforced by `card.ts` superRefine.
 */

import { z } from "zod";

export const ContinuingObligationSchema = z.object({
  reportName: z.string().optional(),
  legalBasis: z.string().min(1),
  triggerOrFrequency: z.string().min(1),
  requiredRecords: z.array(z.string()),
  evidenceToMaintain: z.array(z.string()),
  nextDueWindow: z.string().optional(),
  monitoringSignal: z.string().optional(),
});
export type ContinuingObligation = z.infer<typeof ContinuingObligationSchema>;
